var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
var _excluded = ["columnCount", "displayStyle", "masonryOptions", "className", "elementType", "children", "wrapperPaddings", "windowWidth"], _excluded2 = ["className"], _excluded3 = ["className"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import React from "react";
import classNames from "classnames";
import Masonry from "react-masonry-component";
import { raScreenXsMax, raScreenSmMax, raScreenMdMax, raScreenLgMax } from "@riseart/antd-provider/dist/website/variables.less";
import { SETTINGS } from "./settings";
import { gridFluidCls } from "./Grid.less";
var TOTAL_GRID_COLS = 24;
var BREAKPOINTS = [{
  name: "xs",
  maxWidth: parseInt(raScreenXsMax, 10)
}, {
  name: "sm",
  maxWidth: parseInt(raScreenSmMax, 10)
}, {
  name: "md",
  maxWidth: parseInt(raScreenMdMax, 10)
}, {
  name: "lg",
  maxWidth: parseInt(raScreenLgMax, 10)
}];
var calcItemWidth = /* @__PURE__ */ __name(function calcItemWidth2(_ref) {
  var dimensions = _ref.dimensions, colSettings = _ref.colSettings, wrapperPaddings = _ref.wrapperPaddings, windowWidth = _ref.windowWidth;
  var breakpointKey = "xl";
  BREAKPOINTS.some(function(breakpoint) {
    if (windowWidth <= breakpoint.maxWidth) {
      breakpointKey = breakpoint.name;
      return true;
    }
    return false;
  });
  var columnsPerRow = TOTAL_GRID_COLS / colSettings[breakpointKey];
  var _dimensions$breakpoin = dimensions[breakpointKey], horizontalGutter = _dimensions$breakpoin.horizontalGutter, itemMaxWidth = _dimensions$breakpoin.itemMaxWidth;
  var raWrapperPadding = 2 * parseInt(wrapperPaddings[breakpointKey], 10);
  var itemWidth = (windowWidth + horizontalGutter - raWrapperPadding) / columnsPerRow - horizontalGutter;
  return itemWidth >= itemMaxWidth ? itemMaxWidth : itemWidth;
}, "calcItemWidth");
var GridFluid = /* @__PURE__ */ React.forwardRef(function(_ref2, ref) {
  var _ref2$columnCount = _ref2.columnCount, columnCount = _ref2$columnCount === void 0 ? "4" : _ref2$columnCount, _ref2$displayStyle = _ref2.displayStyle, displayStyle = _ref2$displayStyle === void 0 ? "1" : _ref2$displayStyle, _ref2$masonryOptions = _ref2.masonryOptions, masonryOptions = _ref2$masonryOptions === void 0 ? null : _ref2$masonryOptions, _ref2$className = _ref2.className, className = _ref2$className === void 0 ? null : _ref2$className, _ref2$elementType = _ref2.elementType, elementType = _ref2$elementType === void 0 ? "div" : _ref2$elementType, children = _ref2.children, _ref2$wrapperPaddings = _ref2.wrapperPaddings, wrapperPaddings = _ref2$wrapperPaddings === void 0 ? null : _ref2$wrapperPaddings, _ref2$windowWidth = _ref2.windowWidth, windowWidth = _ref2$windowWidth === void 0 ? null : _ref2$windowWidth, restProps = _objectWithoutProperties(_ref2, _excluded);
  var areChildrenFunction = typeof children === "function";
  var _SETTINGS$columnCount = SETTINGS[columnCount].styles[displayStyle], _SETTINGS$columnCount2 = _SETTINGS$columnCount.grid, typeClassName = _SETTINGS$columnCount2.className, gridSettings = _objectWithoutProperties(_SETTINGS$columnCount2, _excluded2), _SETTINGS$columnCount3 = _SETTINGS$columnCount.col, colClassName = _SETTINGS$columnCount3.className, colSettings = _objectWithoutProperties(_SETTINGS$columnCount3, _excluded3), dimensions = _SETTINGS$columnCount.dimensions;
  var itemWidth = areChildrenFunction && wrapperPaddings && windowWidth ? calcItemWidth({
    colSettings,
    dimensions,
    wrapperPaddings,
    windowWidth
  }) : null;
  return /* @__PURE__ */ React.createElement(Masonry, _extends({
    ref,
    className: classNames(gridFluidCls, typeClassName, className),
    elementType,
    options: _objectSpread({
      transitionDuration: 0
    }, masonryOptions),
    disableImagesLoaded: false,
    updateOnEachImageLoad: true
  }, gridSettings, restProps), areChildrenFunction ? children(itemWidth) : children);
});
export {
  GridFluid
};
